<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="col-form-label">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.inquiry')
            }}
          </label>
          <a-select style="width: 100%" v-model="model.inquiry_id" :options="inquiryLists" showSearch allowClear
            :filterOption="(input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0"
            @change="onChangeInquiry"
          >
          </a-select>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-md-12 col-form-label">
          {{ $t('school.academic.operation.profile_mgt.studentProfile.nameKh') }}
        </label>
        <div class="col-md-12">
          <fieldset>
            <div class="row form-group">
              <div class="col-md-6">
                <input type="text" ref="first_name_kh" v-model.trim="model.first_name_kh" class="form-control" :class="{
                  'is-invalid': errors.has('first_name_kh')
                }" :placeholder="$t('school.academic.operation.profile_mgt.studentProfile.firstName')" />
                <div class="invalid-feedback" v-if="errors.has('first_name_kh')">
                  {{ errors.first('first_name_kh') }}
                </div>
              </div>
              <div class="col-md-6">
                <input type="text" v-model.trim="model.last_name_kh" class="form-control" :class="{
                  'is-invalid': errors.has('last_name_kh')
                }" :placeholder="$t('school.academic.operation.profile_mgt.studentProfile.lastName')" />
                <div class="invalid-feedback" v-if="errors.has('last_name_kh')">
                  {{ errors.first('last_name_kh') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input type="text" class="form-control" readonly :value="fullNameKh" :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.fullNameKh'
                  )
                " />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-md-12 col-form-label required">
          {{ $t('school.academic.operation.profile_mgt.studentProfile.nameEn') }}
        </label>
        <div class="col-md-12">
          <fieldset>
            <div class="row form-group">
              <div class="col-md-6">
                <input type="text" v-model.trim="model.first_name_en" class="form-control" :class="{
                  'is-invalid': errors.has('first_name_en')
                }" :placeholder="$t('school.academic.operation.profile_mgt.studentProfile.firstName')" />
                <div class="invalid-feedback" v-if="errors.has('first_name_en')">
                  {{ errors.first('first_name_en') }}
                </div>
              </div>
              <div class="col-md-6">
                <input type="text" v-model.trim="model.last_name_en" class="form-control" :class="{
                  'is-invalid': errors.has('last_name_en')
                }" :placeholder="$t('school.academic.operation.profile_mgt.studentProfile.lastName')" />
                <div class="invalid-feedback" v-if="errors.has('last_name_en')">
                  {{ errors.first('last_name_en') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input type="text" class="form-control" readonly :value="fullNameEn" :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.fullNameEn'
                  )
                " />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-md-12 col-form-label required">
          {{ $t('school.academic.operation.profile_mgt.studentProfile.gender') }}
        </label>
        <div class="col-md-12">
          <div class="radio radio-css radio-inline">
            <input type="radio" id="male" v-model="model.gender" value="Male" :class="{
              'is-invalid': errors.has('gender')
            }" />
            <label for="male">Male</label>
          </div>
          <div class="radio radio-css radio-inline">
            <input type="radio" id="female" v-model="model.gender" value="Female" :class="{
              'is-invalid': errors.has('gender')
            }" />
            <label for="female">Female</label>
          </div>
          <div class="invalid-feedback" v-if="errors.has('gender')">
            {{ errors.first('gender') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-6">
          <label class="col-form-label">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.phone')
            }}
          </label>
          <input type="text" class="form-control" v-model="model.phone" />
        </div>
        <div class="col-md-6">
          <label class="col-form-label">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.telegram')
            }}
          </label>
          <input type="text" class="form-control" v-model="model.telegram" />
        </div>
      </div>
      <div class="row form-group">
        <label class="col-md-12 col-form-label required">
          {{
            $t('school.academic.operation.profile_mgt.studentProfile.className')
          }}
        </label>
        <div class="col-md-12">
          <ts-select-class v-model.number="model.class_id" />
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12 ts-flex ts-space-x-2 ts-justify-end">
          <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
          <ts-button @click.prevent="onSave" color="primary">{{ $t('save') }}</ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import TsSelectClass from '@/components/SelectClass'
import { mapActions } from 'vuex'
export default {
  name: 'createNewStudent',
  components: {
    TsSelectClass
  },
  data() {
    return {
      loading: false,
      inquiryLists: [],
      inquiryFollowUp: [],
      model: {
        first_name_kh: '',
        last_name_kh: '',
        first_name_en: '',
        last_name_en: '',
        phone: '',
        telegram: '',
        inquiry_id: '',
        gender: null,
        class_id: null
      },
      errors: new Errors()
    }
  },
  computed: {
    fullNameEn() {
      return this.model.last_name_en + " " + this.model.first_name_en
    },
    fullNameKh() {
      return this.model.last_name_kh + " " + this.model.first_name_kh
    }
  },
  created () {
    this.getInqiryList()
  },
  methods: {
    ...mapActions('invoice', ['createNewStudent', 'invoiceFormView']),
    onSave() {
      this.errors = new Errors()
      this.loading = true
      this.createNewStudent(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('student', response.data)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getInqiryList() {
      this.loading = true,
      this.invoiceFormView({
        fnName: 'inquiryList'
      })
      .then(({ data }) => {
        this.loading = false,
        this.inquiryLists = data.inquiryList.map(el => ({
          value: el.inquiry_id,
          label: el.full_name_en + ' ' +'(' + el.action_status + ')'
        }))
        this.inquiryFollowUp = data.inquiryList
        .map(el => ({
          data: el
        }))
      })
      .catch((error) => {
        this.$toasted.error(error.message)
      })
    },
    onChangeInquiry(){
      this.inquiryFollowUp
      .filter(i => i.data.inquiry_id == this.model.inquiry_id)
      .map((inquiry) => {
        this.model.first_name_kh = inquiry.data.first_name_kh != null ? inquiry.data.first_name_kh : ''
        this.model.last_name_kh = inquiry.data.last_name_kh != null ? inquiry.data.last_name_kh : ''
        this.model.first_name_en = inquiry.data.first_name_en
        this.model.last_name_en = inquiry.data.last_name_en
        this.model.gender = inquiry.data.gender == 'M' ? 'Male' : 'Female'
        this.model.phone = inquiry.data.contact_number
        this.model.telegram = inquiry.data.telegram
      })
    }
  },
}
</script>
